import type { WebsitePage, Draft, RecentPost, Subscriber, PendingInvite, PressReleaseArticle, Comment, StrategicPillar, Programme, Publication, PhotoGalleryFolder, Photo } from '../types';

const userColors = [
    'bg-green-100 text-green-800',
    'bg-blue-100 text-blue-800',
    'bg-purple-100 text-purple-800',
    'bg-pink-100 text-pink-800',
    'bg-indigo-100 text-indigo-800',
    'bg-orange-100 text-orange-800',
];

export const mockDrafts: Draft[] = [
    {
        id: 1,
        title: "Open letter from the Global Space Coun...",
        date: '09:12am',
        author: 'Jessica Daniel'
    },
    {
        id: 2,
        title: "Open letter from the Global Space Coun...",
        date: '09:12am',
        author: 'Jessica Daniel'
    },
    {
        id: 3,
        title: "Open letter from the Global Space Coun...",
        date: '18 Jul 25',
        author: 'Jessica Daniel'
    },
];

export const mockRecentPosts: RecentPost[] = [
    {
        id: 1,
        title: 'CALL FOR APPLICATIONS -- AFRICAN SPACE SOLUTIONS MARKET...',
        date: '18 Jul 25',
        author: 'Jessica Daniel',
        image: 'https://images.unsplash.com/photo-1628527304948-06157ee3c8a6?q=80&w=600&auto=format&fit=crop',
        views: 600,
        comments: 600,
    },
    {
        id: 2,
        title: 'The Stars Belong to Africa Too',
        date: '18 Jul 25',
        author: 'Jessica Daniel',
        image: 'https://images.unsplash.com/photo-1534294668821-28a3054f4256?q=80&w=600&auto=format&fit=crop',
        views: 600,
        comments: 600,
    },
    {
        id: 3,
        title: 'Visit to the SENSAT Centre in Senegal',
        date: '20 Jul 25',
        author: 'Jessica Daniel',
        image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=600&auto=format&fit=crop',
        views: 600,
        comments: 600,
    },
    {
        id: 4,
        title: 'Open letter from the Global Space Council: Governments must addre...',
        date: '18 Jul 25',
        author: 'Jessica Daniel',
        image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=600&auto=format&fit=crop',
        views: 600,
        comments: 600,
    },
];


export const mockPages: WebsitePage[] = [
    { id: 1, name: 'Procurement', lastUpdate: '08/08/2025 12:56 PM', updatedBy: { name: 'Adam Ant', initials: 'AA', bgColor: userColors[0] } },
    { id: 2, name: 'Careers', lastUpdate: '08/08/2025 12:56 PM', updatedBy: { name: 'Adam Ant', initials: 'AA', bgColor: userColors[0] } },
    { id: 3, name: 'Press Release', lastUpdate: '08/08/2025 12:56 PM', updatedBy: { name: 'Betty Boop', initials: 'BB', bgColor: userColors[1] } },
    { id: 4, name: 'Events', lastUpdate: '08/08/2025 12:56 PM', updatedBy: { name: 'Adam Ant', initials: 'AA', bgColor: userColors[0] } },
    { id: 5, name: 'Resources', lastUpdate: '08/08/2025 12:56 PM', updatedBy: { name: 'Charlie Chaplin', initials: 'CC', bgColor: userColors[2] } },
    { id: 6, name: 'Contact Us', lastUpdate: '08/08/2025 12:56 PM', updatedBy: { name: 'Adam Ant', initials: 'AA', bgColor: userColors[0] } },
    { id: 7, name: 'About Us', lastUpdate: '07/08/2025 10:15 AM', updatedBy: { name: 'David Duchovny', initials: 'DD', bgColor: userColors[3] } },
    { id: 8, name: 'Gallery', lastUpdate: '06/08/2025 09:00 AM', updatedBy: { name: 'Betty Boop', initials: 'BB', bgColor: userColors[1] } },
    { id: 9, name: 'Blog', lastUpdate: '05/08/2025 03:30 PM', updatedBy: { name: 'Eva Gabor', initials: 'EG', bgColor: userColors[4] } },
    { id: 10, name: 'Services', lastUpdate: '04/08/2025 11:20 AM', updatedBy: { name: 'Charlie Chaplin', initials: 'CC', bgColor: userColors[2] } },
];

export const mockSubscribers: Subscriber[] = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    email: `mmuthekjiora${i > 0 ? i + 1 : ''}@gmail.com`,
    joinDate: 'July 15, 2025'
}));

export const mockPendingInvites: PendingInvite[] = [
    {
        id: 1,
        name: 'Shola Orji',
        email: 'sholaorji@afsa.com',
        inviteDate: 'July 15, 2025',
        initials: 'SO',
        bgColor: 'bg-orange-200 text-orange-800'
    }
];

export const mockPressReleases: PressReleaseArticle[] = [
  { id: 101, title: 'The Stars Belong to Africa Too', author: 'Jessica Daniel', date: '18 Jul 25', status: 'published', views: 900, commentsCount: 900, coverImage: 'https://images.unsplash.com/photo-1534294668821-28a3054f4256?q=80&w=600&auto=format&fit=crop' },
  { id: 102, title: 'Space and Sovereignty: Africa’s Ascent in a Changing World', author: 'Jessica Daniel', date: '18 Jul 25', status: 'published', views: 1200, commentsCount: 45, coverImage: 'https://images.unsplash.com/photo-1628527304948-06157ee3c8a6?q=80&w=600&auto=format&fit=crop' },
  { id: 103, title: 'Visit to the SENSAT Centre in Senegal', author: 'Jessica Daniel', date: '18 Jul 25', status: 'draft', views: 0, commentsCount: 0 },
  { id: 104, title: 'Inaugural Meeting of the Council of the African Space Agency', author: 'Jessica Daniel', date: '18 Jul 25', status: 'draft', views: 0, commentsCount: 0 },
  { id: 105, title: 'Inauguration of the African Space Agency: A Milestone for Africa’s...', author: 'Jessica Daniel', date: '18 Jul 25', status: 'draft', views: 0, commentsCount: 0 },
  { id: 106, title: 'Cameroon’s Remy Bouelet Wins AfSA Logo Competition', author: 'Jessica Daniel', date: '18 Jul 25', status: 'draft', views: 0, commentsCount: 0, coverImage: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=600&auto=format&fit=crop' },
];

export const mockStrategicPillars: StrategicPillar[] = [
  { 
    id: 201, 
    title: 'Earth Observation', 
    author: 'Jessica Daniel', 
    date: '18 Jul 25 | 12:30pm', 
    status: 'published', 
    views: 900, 
    coverImage: 'https://images.unsplash.com/photo-1541185934-01b600ea069c?q=80&w=600&auto=format&fit=crop',
    highlightOptions: { landingPage: false, whoWeAre: true, countries: true, history: false, members: false }
  },
  { 
    id: 202, 
    title: 'Satellite Connectivity', 
    author: 'Jessica Daniel', 
    date: '18 Jul 25', 
    status: 'draft', 
    views: 0, 
    coverImage: 'https://images.unsplash.com/photo-1588466585717-220deaa3a0b4?q=80&w=600&auto=format&fit=crop',
    highlightOptions: { landingPage: false, whoWeAre: false, countries: false, history: false, members: false }
  },
  { 
    id: 203, 
    title: 'Navigation & Positioning', 
    author: 'Jessica Daniel', 
    date: '18 Jul 25', 
    status: 'draft', 
    views: 0,
    coverImage: undefined,
    highlightOptions: { landingPage: false, whoWeAre: false, countries: false, history: false, members: false }
  },
];

export const mockProgrammes: Programme[] = [
  {
    id: 301,
    title: 'Youth for Space Initiative',
    author: 'Jessica Daniel',
    date: '25 Aug 25',
    status: 'published',
    views: 1500,
    coverImage: 'https://images.unsplash.com/photo-1522071820081-009f0129c7da?q=80&w=600&auto=format&fit=crop',
  },
  {
    id: 302,
    title: 'Pan-African Satellite Constellation Project',
    author: 'Admin',
    date: '15 Sep 25',
    status: 'published',
    views: 2200,
    coverImage: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=600&auto=format&fit=crop',
  },
  {
    id: 303,
    title: 'STEM Education Outreach Programme',
    author: 'Jessica Daniel',
    date: '01 Oct 25',
    status: 'draft',
    views: 0,
    coverImage: undefined,
  }
];

export const mockComments: Comment[] = [
    { id: 1, author: 'Rachel Kim', email: 'rachel.kim64@example.com', text: "About time someone called out the dangers of overcrowding in orbit. I've been following the news about space debris for years, and it's frustrating how little urgency there seems to be. This isn't just a 'future generation' issue — it's happening now, and even a tiny shard of metal traveling at orbital speed can destroy a satellite instantly. We can't just keep launching things without thinking about where they'll end up." },
    { id: 2, author: 'Luis Ortega', email: 'luis.ortega23@example.com', text: "Exactly. The Kessler Syndrome — where debris collisions cause a chain reaction — isn't some far-off sci-fi concept anymore. If we don't put preventive measures in place now, we'll hit a point where launching anything safely will be almost impossible." },
    { id: 3, author: 'James Carter', email: 'j.carter.dev@example.com', text: "Governments will probably drag their feet like they did with climate change. We need private companies to step up too." },
    { id: 4, author: 'Owen Park', email: 'owen.park55@example.com', text: "Does this mean we'll have space traffic laws soon? Like stop signs in zero gravity? It's kind of funny to think about, but honestly, the way things are going, I wouldn't be surprised if we needed actual orbital 'lanes' to keep satellites and spacecraft from smashing into each other." },
    { id: 5, author: 'Sophia Nguyen', email: 'sophia.nguyen@example.com', text: "Haha, not exactly stop signs, but yes — orbital traffic management is something agencies are already discussing. They're even considering systems where satellites would need to 'check in' before adjusting their position, kind of like how planes communicate with air traffic control." },
];

export const mockPublications: Publication[] = [
    { id: 401, title: 'African Space Policy Framework', category: 'Legal Foundation', author: 'Jessica Daniel', date: '18 Jul 25', status: 'published', views: 600, downloads: 600, tag: 'Legal Foundation' },
    { id: 402, title: 'African Space Strategy', category: 'Legal Foundation', author: 'Jessica Daniel', date: '18 Jul 25', status: 'published', views: 600, downloads: 600 },
    { id: 403, title: 'African Space Agency Act', category: 'Legal Foundation', author: 'Jessica Daniel', date: '18 Jul 25', status: 'published', views: 600, downloads: 600 },
    { id: 404, title: 'Member State Agreements', category: 'AFSA', author: 'Jessica Daniel', date: '18 Jul 25', status: 'published', views: 600, downloads: 600 },
    { id: 405, title: 'Annual Report 2024', category: 'Reports', author: 'Admin', date: '10 Jan 25', status: 'draft', views: 0, downloads: 0 },
];

export const mockPhotoGalleryFolders: PhotoGalleryFolder[] = [
    { id: 'inauguration', name: 'Inauguration', date: '12/12/23', imageCount: 8, coverImage: 'https://images.unsplash.com/photo-1541185934-01b600ea069c?q=80&w=600&auto=format&fit=crop', isPublished: true },
    { id: 'conference-2024', name: 'Annual Conference 2024', date: '10/11/24', imageCount: 15, coverImage: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=600&auto=format&fit=crop', isPublished: true },
    { id: 'senegal-visit', name: 'Visit to Senegal', date: '05/09/24', imageCount: 5, coverImage: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=600&auto=format&fit=crop', isPublished: false },
];

export const mockPhotos: Photo[] = [
    { id: 501, folderId: 'inauguration', title: 'Dignitaries Arriving', date: '12/12/23', imageUrl: 'https://images.unsplash.com/photo-1541848156497-6afd341e3c35?q=80&w=600', isKeyHighlight: false },
    { id: 502, folderId: 'inauguration', title: 'Ribbon Cutting Ceremony', date: '12/12/23', imageUrl: 'https://images.unsplash.com/photo-1587593292411-9585c545f448?q=80&w=600', isKeyHighlight: true },
    { id: 503, folderId: 'inauguration', title: 'Keynote Address', date: '12/12/23', imageUrl: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=600', isKeyHighlight: false },
    { id: 504, folderId: 'inauguration', title: 'Panel Discussion', date: '12/12/23', imageUrl: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=600', isKeyHighlight: false },
    { id: 505, folderId: 'inauguration', title: 'Networking Session', date: '12/12/23', imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=600', isKeyHighlight: false },
    { id: 506, folderId: 'inauguration', title: 'Group Photo', date: '12/12/23', imageUrl: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=600', isKeyHighlight: true },
    { id: 507, folderId: 'inauguration', title: 'AFSA Headquarters', date: '12/12/23', imageUrl: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?q=80&w=600', isKeyHighlight: false },
    { id: 508, folderId: 'inauguration', title: 'Closing Remarks', date: '12/12/23', imageUrl: 'https://images.unsplash.com/photo-1551828453-93575231a52b?q=80&w=600', isKeyHighlight: false },
];